export const ENV_DEV = 'dev';
export const ENV_PREVIEW = 'preview';
export const ENV_LIVE = 'live';

export const APP_ENV =
    process.env.ENVIRONMENT === 'local'
        ? 'dev'
        : // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          process.env.ENVIRONMENT ?? 'dev';
